import * as types from "./actions";
import { MAX_INT, PRODUCTCLASS_CODE } from "../../../../utils/constants";

const defaultState = {
    list: [],
    tableHeader: [
        {
            label: "商品分類コード",
            button: false,
            id: true,
            rightAlign: true
        },
        {
            label: "商品分類名",
            button: false
        },
        {
            label: "編集",
            button: true
        },
        {
            label: "コピー",
            button: true
        }
    ],
    tableColumns: [
        "productClassCode",
        "productClassName"
    ],
    form: [
        {
            type: "number",
            label: "商品分類コード",
            placeholder: "",
            max: MAX_INT,
            name: "productClassCode",
            value: "",
            required: true,
            disabled: false,
            validationState: null,
            readOnly: true
        },
        {
            type: "text",
            label: "商品分類名",
            placeholder: "",
            minLength: 1,
            maxLength: 40,
            name: "productClassName",
            required: true,
            disabled: false
        }
    ],
    select: []
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {

        case types.LIST:
            let productClasses = [];
            action.payload.map(item => productClasses.push({ name: PRODUCTCLASS_CODE, label: "["+item.productClassCode+"]"+item.productClassName, value: item.productClassCode }));
            return { ...state, list: action.payload, select: productClasses };

        default: // need this for default case
            return state;
    }
};
